
import Table from "../../table/Table";
import { useState, useCallback } from "react";
import { toast } from "react-toastify";
import { Button, Card, Col, Modal, ModalHeader, ModalBody, ModalFooter, Container } from "reactstrap";
import { useNavigate } from "react-router-dom";
import ApiService from "../../../services/apiService";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import { useAppSelector } from "../../../reduxToolkit/hooks";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import { distributaryZoneTitle, Pages, Configuration } from "../../../constants";
import { usePagination } from "../../../hooks/usePagination";
import RightIcon from "../../svg/RightIcon";
import LeftIcon from "../../svg/LeftButton";
import FilterIcon from "../../svg/FilterIcon";

import AddIcon from "../../svg/AddIcon";
import DownloadExcel from "../../downloadExcel/DownloadExcel";
import LoadingComponent from "../../lodingComponent";
import { Filter } from "react-feather";
const DistributaryList = () => {


  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState("");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const role = useAppSelector((state) => state.role.role);
  /* const getDistributaries = async () => {
     try {
       const response = await ApiService.axiosApi('/dZone', {
         method: 'GET',
       });
 
       if (response.success) {
         setDistributaries(response.data);
       } else {
         toast.error(response.data.message);
       }
     } catch (error: any) {
       toast.error(error.message);
     }
   };
 
   useEffect(() => {
     getDistributaries();
   }, [refresh]);*/

  const {
    data,
    pageNumber,
    setPageNumber,
    pageSize,
    totalCount,
    setRefresh,
    setSearchQuery,
    searchQuery,
    filterOn,
    setSortBy,
    loading
  } = usePagination({
    endpoint: `/dzone`,
    filterOn: 'Distributary_Zone',
    enabled: true
  })
  const totalPages = Math.ceil(totalCount / pageSize);

  const handleNext = useCallback(() => {
    setPageNumber((prev) => Math.min(totalPages, prev + 1))
  }, [setPageNumber, totalPages])



  const handlePrev = useCallback(() => {
    setPageNumber((prev) => Math.max(1, prev - 1))
  }, [setPageNumber, totalPages])

  const handleDelete = (id: string) => {
    setSelectedId(id);
    setIsDeleteModalOpen(true);
  };

  const handleDeleteDistributary = async () => {
    try {
      const response = await ApiService.axiosApi(`/dzone/${selectedId}`, {
        method: 'DELETE',
      });

      if (response.success) {
        toast.success("Distributary deleted successfully");
        setIsDeleteModalOpen(false);
        setRefresh(prev => !prev);
      } else {
        toast.error(response.message);
      }
    } catch (error: any) {
      toast.error(error.message);
    }
  };

  const handleUpdate = (id: string) => {
    navigate(`/distributary-zone-update/${id}`);
  };

  return (
    <>
      <Breadcrumbs mainTitle={distributaryZoneTitle} parent={Configuration} />
      
        <Card>
          <CommonCardHeader title="Distributary List" headClass="pb-3" />
          <div className="d-flex justify-content-between">
            <div style={{ marginLeft: '10px' }} className='align-items-center flex-row d-flex'>
              <div>
                <input
                  type="text"
                  className="search-input"
                  placeholder="...search"
                  value={searchQuery}
                  onChange={(e) => {
                     setSearchQuery(e.target.value)
                     setPageNumber(1)
                  }}

                />
              </div>
              <div>
                <button className="filter-button mx-2 p-1" style={{ height: '30px' }} onClick={() => setSortBy('Distributary_Zone')}>
                 <Filter/>
                </button>
              </div>

            </div>
            {role === "Administrator" && (
              <div className="d-flex justify-content-end">

                <Button onClick={() => navigate('/distributary-zone-form')} size="md" color="primary" className="mb-2 mx-1 px-2"><div style={{ display: 'flex', alignItems: 'center', gap: '5px', justifyContent: 'center' }}>
                  <AddIcon />
                </div>
                </Button>

              </div>
            )}
          </div>
          {loading?<LoadingComponent/>: <Table
            data={data}
            columns={[
              { header: "Distributary/Zone", accessor: "distributary_Zone" },
              { header: "Toatal Area", accessor: "totalArea" }
            ]}
            buttons={[
              { label: "Edit", onClick: handleUpdate, color: "primary", className: "me-2" },
              { label: "Delete", onClick: handleDelete, color: "danger", }
            ]}
          />}
         
          <div className=" d-flex justify-content-end align-content-center" style={{ marginRight: '10px', marginTop: '10px' }}>
            <p style={{ marginRight: '10px', marginTop: '8px' }}>
              Page {pageNumber} of {totalPages}
            </p>
            <button
              onClick={handlePrev}
              disabled={pageNumber === 1}
              className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
            >
              <LeftIcon className="icon" />
            </button>
            <button
              className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
              onClick={handleNext}
              disabled={pageNumber === totalPages}
            >
              <RightIcon className="icon" />
            </button>
          </div>
        </Card>
        <Modal isOpen={isDeleteModalOpen} toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}>
          <ModalHeader>Delete Distributary</ModalHeader>
          <ModalBody>Are you sure you want to delete this distributary?</ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={handleDeleteDistributary}>Delete</Button>
            <Button color="secondary" onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>
          </ModalFooter>
        </Modal>
      
    </>
  );
};

export default DistributaryList;
